import { FC } from 'react';
import MapBox from './containers/map-box/MapBox';

const MainMap: FC = () => {
	return <MapBox />;
};

export default MainMap;
